import React, { useRef, useState } from "react";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHFeriadoDel } from "services/services-mia/programa-salud/feriados/RNHFeriadoDel";

/**
 * Baja de un feriado.
 *
 * Solo el nombre, como el resto de las bajas del modulo: lo que se confirma es CUAL se
 * borra, y el tipo no ayuda a decidir eso.
 */
export default function DeleteModal({ row, updateList, closeModal, setterRowSelected }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  const eliminarFeriado = async () => {
    setInRequest(true);
    const respuesta = await RNHFeriadoDel(credentials, {
      id: row?.id,
      version: row?.version,
    });
    setInRequest(false);

    if (!respuesta.ok) return;

    setSnackBarInfo({
      message: "Feriado eliminado correctamente",
      severity: "success",
      open: true,
    });
    formikRef.current.resetForm();
    updateList();
    setterRowSelected({ status: false, row: {} });
    closeModal();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        nombre: row?.nombre ?? "",
      }}
      onSubmit={() => {
        eliminarFeriado();
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <FormikTextInput
            fullWidth={true}
            name="nombre"
            labelText="Nombre"
            readOnly
          />
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Eliminar" }}
            onCloseModal={closeModal}
          />
          {inRequest && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
